<template>
    <div class="mainPage">
        <!-- <div class="left">
            <img src="../img/logo.png" alt="">
        </div> -->
        <div class="tabRight">
            <navbar/>
        </div>
         <div class="middle">
             <transition :name="transitionName">
                <router-view></router-view>
            </transition>
        </div>
    </div>
</template>

<script>
import navbar from './navbar'
export default { 
    name: 'mainpage',
    components: {
        navbar
    },
    data: function () {
        return {
            transitionName:''
        }
    },
    watch: {
      // 使用watch 监听$router的变化
      $route (to, from) {
        if (to.meta.index > from.meta.index){
         this.transitionName = 'slide-left';
        } else{
          this.transitionName = 'slide-right';
       }

    }
    },

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.mainPage {
    width: 100%;
    height: 100%;
    background-image: url(../img/bg.png);
    background-repeat: no-repeat;
    background-size: cover;
    overflow-x: auto;
    overflow-y: hidden;
    white-space: nowrap;
    .left {
        width: 240px;
        height: 100%;
        position: absolute;
        img {
            width: 182px;
            margin-top: 41px;
            margin-left: 57px;
        }

    }
    .tabRight {
        float: right;
        height: 100%;
        width: 240px;
        //margin-right: 30px;
    }
    .middle {
        height: 100%;
        // margin-right: 240px;
        min-width: 800px;
        // max-width: 1400px;
        width: calc(100% - 240px);
        position: relative;
    }
}
    .slide-top-enter-active,
    .slide-bottom-enter-active,
   .slide-right-enter-active,
   .slide-right-leave-active,
   .slide-left-enter-active,
   .slide-left-leave-active {
     will-change: transform;
     transition: all 500ms;
     position: absolute;
   }.slide-right-enter {
     opacity: 0;
    transform: translate3d(0, -100%, 0);
  }.slide-right-leave-active {
    opacity: 0;
    transform: translate3d(0, 100%, 0);
  }.slide-left-enter {
    opacity: 0;
    transform: translate3d(0, 100%, 0);
  }.slide-left-leave-active {
    opacity: 0;
    transform: translate3d(0, -100%, 0);
  }
</style>
